// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { DynProperty } from '@shared/commons/DynProperty';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class OverlaysManagerItem extends BaseItem {
    constructor(overlay) {
        super();
        this.Overlay = overlay;
        const visibilityButton = new QuickTableEditingInfo(DynProperty.VISIBILITY_BUTTON);
        visibilityButton.TooltipKey = 'ObjectManagerItem.Visible.ToolTip';
        this.QuickTableEditingInfoMap[OverlaysManagerItem.VISIBLE_COL_INDEX] = visibilityButton;
        const settingsButton = new QuickTableEditingInfo(DynProperty.SETTINGS_BUTTON);
        settingsButton.TooltipKey = 'ObjectManagerItem.Settings.ToolTip';
        this.QuickTableEditingInfoMap[OverlaysManagerItem.SETTINGS_COL_INDEX] = settingsButton;
        const closeButton = new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
        closeButton.TooltipKey = 'ObjectManagerItem.Remove.ToolTip';
        this.QuickTableEditingInfoMap[OverlaysManagerItem.REMOVE_COL_INDEX] = closeButton;
    }
    getItemSubject() {
        return this.Overlay;
    }
    ColumnCount() {
        return OverlaysManagerItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const par = OverlaysManagerItem.columnsParams[i];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    GetMenuIndex(headerKey) {
        if (OverlaysManagerItem.ListMenuIndex[headerKey]) {
            return OverlaysManagerItem.ListMenuIndex[headerKey];
        }
        else {
            return 1000;
        }
    }
    getColumnValue(column) {
        switch (column) {
            case OverlaysManagerItem.NAME_COL_INDEX:
                return this.Overlay.ActiveInstrument.DisplayName();
            case OverlaysManagerItem.VISIBLE_COL_INDEX:
                return this.Overlay.mainPriceRenderer.Visible;
            default:
                return '';
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let FormattedValue = null;
        switch (column) {
            case OverlaysManagerItem.NAME_COL_INDEX:
                FormattedValue = value;
                break;
        }
        return new ColumnData(value, FormattedValue);
    }
}
OverlaysManagerItem.NAME_COL_INDEX = 0;
OverlaysManagerItem.VISIBLE_COL_INDEX = 1;
OverlaysManagerItem.SETTINGS_COL_INDEX = 2;
OverlaysManagerItem.REMOVE_COL_INDEX = 3;
OverlaysManagerItem.columnsParams = [
    new ColumnParams('ObjectManagerItem.Name', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Visible', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Settings', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Remove', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false)
];
OverlaysManagerItem.ListMenuIndex = [
    'ObjectManagerItem.Name',
    'ObjectManagerItem.Visible',
    'ObjectManagerItem.Settings',
    'ObjectManagerItem.Remove'
];
